import { useState, useEffect } from 'react'
import { getCurrentPlan, getCurrentPlanFeatures, isFeatureEnabled, PLAN_TYPES } from '../config/planConfig'

// プラン機能管理Hook
export const usePlanFeatures = () => {
  const [currentPlan, setCurrentPlan] = useState(getCurrentPlan())
  const [planFeatures, setPlanFeatures] = useState(getCurrentPlanFeatures())

  useEffect(() => {
    const plan = getCurrentPlan()
    const features = getCurrentPlanFeatures()
    
    setCurrentPlan(plan)
    setPlanFeatures(features)
    
    // sessionStorageの変更を監視（プラン変更検知）
    const handleStorageChange = (e) => {
      if (e.key === 'alsok_plan_type' || e.type === 'storage') {
        const newPlan = getCurrentPlan()
        const newFeatures = getCurrentPlanFeatures()
        
        console.log(`🔄 プラン変更検知: ${currentPlan} → ${newPlan}`)
        setCurrentPlan(newPlan)
        setPlanFeatures(newFeatures)
      }
    }
    
    // storage eventとcustom eventの両方を監視
    window.addEventListener('storage', handleStorageChange)
    window.addEventListener('planChanged', handleStorageChange)
    
    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('planChanged', handleStorageChange)
    }
  }, [])

  // プラン変更時の更新
  const refreshPlan = () => {
    const plan = getCurrentPlan()
    const features = getCurrentPlanFeatures()
    
    setCurrentPlan(plan)
    setPlanFeatures(features)
  }

  return {
    currentPlan,
    planFeatures,
    isFeatureEnabled,
    refreshPlan,
    // 個別機能チェック用のヘルパー（現在のプランベース）
    features: planFeatures.features
  }
}